import { OFFICE_DESIGNS } from "./officeDesignTemplates";

export function matchOfficeDesign({ east, west, north, south }) {
  const e = Number(east) || 0;
  const w = Number(west) || 0;
  const n = Number(north) || 0;
  const s = Number(south) || 0;

  const avgWidth = (e + w) / 2;
  const avgLength = (n + s) / 2;
  const plotArea = avgWidth * avgLength;

  let selectedDesign = OFFICE_DESIGNS[0];

  if (plotArea > 350 && plotArea <= 650) {
    selectedDesign = OFFICE_DESIGNS[1];
  }

  if (plotArea > 650) {
    selectedDesign = OFFICE_DESIGNS[2];
  }

  return {
    plotArea: Number(plotArea.toFixed(2)),
    avgWidth: Number(avgWidth.toFixed(2)),
    avgLength: Number(avgLength.toFixed(2)),
    selectedDesign,
  };
}

export function getFaceSuggestion(frontSide) {
  if (!frontSide) return "Front side select karo.";
  return `Office ka main entrance ${frontSide} face par rakhna suitable rahega.`;
}